<div
        class="section padding-top-120 padding-top-mob-nav section-background-rana-vision"
>
    <div class="section-1400">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div
                        class="col-sm-10 col-md-8 col-lg-6 align-self-center pr-lg-4 pr-xl-5 text-center text-lg-right pb-5 pb-lg-0 mb-4 mb-lg-0
           border-4  "
                >
                    <h6 class="color-primary text-uppercase mb-2">
                        Vision for the future
                    </h6>
                    <h3 class="display-8 mb-4">
            <span class="font-weight-600"
            >Let’s honor our past, embrace our present,</span
            ><br/><span class="title-line-bottom font-weight-700">
              and shape a brighter future—together</span
                    ><span class="font-weight-600">.</span>
                    </h3>
                    <p class="lead mb-5">
                        At the Rajput Association of North America (RANA), our vision is to
                        inspire and empower the Rajput community across North America while
                        honoring the rich cultural and historical heritage of Rajputs. We
                        strive to create a vibrant, united community that thrives in the
                        modern world while staying deeply connected to its traditions,
                        values, and legacy.
                    </p>
                    <p class="lead mb-5">
                        RANA envisions a future where every member of our community feels
                        proud of their heritage and empowered to make meaningful
                        contributions to society. By fostering unity, promoting our values,
                        and creating opportunities for growth, we aim to ensure the Rajput
                        legacy continues to inspire generations to come.
                    </p>
                </div>
                <div
                        class="col-sm-10 col-md-8 col-lg-6 img-wrap align-self-center pl-lg-4 pl-xl-5"
                >
                    <div class="row">
                        <div class="col-12">
                            <div class="section services-wrap-3-back-dots">
                                <div class="row justify-content-center justify-content-lg-end">
                                    <div class="col-sm-5 col-lg-6 col-xl-5">
                                        <div class="row justify-content-sm-end">
                                            <div
                                                    class="col-sm-10"
                                                    data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s"
                                            >
                                                <div
                                                        class="section border-4 services-wrap-3 bg-blue p-4"
                                                >
                                                    <h5 class="mb-3">
                                                        Preserving Rajputana <br/>Heritage
                                                    </h5>
                                                    <p class="mb-0 text-right">
                                                        <i class="uil uil-brush-alt size-40"></i>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                                class="section border-4 services-wrap-3 bg-purple p-4 mt-4"
                                                data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s"
                                        >
                                            <h5 class="mb-1">
                                                Building a <br/>Supportive Community
                                            </h5>
                                            <p class="mb-3 mb-sm-5 pb-sm-5">
                                                Empowering Future Generations
                                            </p>
                                            <p class="mb-0 text-right">
                                                <i class="uil uil-auto-flash size-40"></i>
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                            class="col-sm-5 col-lg-6 col-xl-5"
                                            data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s"
                                    >
                                        <div
                                                class="section border-4 services-wrap-3 bg-pink p-4 mt-4 mt-sm-5"
                                        >
                                            <h5 class="mb-1">
                                                Promoting Equality and <br/>Inclusivity
                                            </h5>
                                            <p class="mb-3 mb-sm-5 pb-sm-3">
                                                Strengthening Global Connections
                                            </p>
                                            <p class="mb-0 text-right">
                                                <i class="uil uil-image-check size-40"></i>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="section over-hide">
    <div class="section-1400">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-6 col-md-4 col-lg-3 text-center">
                    <div class="section divider"></div>
                </div>
            </div>
        </div>
        <div
                class="container-fluid padding-top-bottom-80"
                data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s"
        >
            <div class="row justify-content-center">
                <div class="col-md-6 col-lg-3 text-center border-counters-right">
                    <div class="counter-big-num mb-0 font-weight-400">
                        <span class="counter">1500</span>+
                    </div>
                    <p
                            class="lead mb-0 py-4 font-weight-600 position-relative z-bigger color-dark-blue"
                    >
                        Rajput Families
                    </p>
                </div>
                <div
                        class="col-md-6 col-lg-3 mt-5 mt-md-0 text-center border-counters-right"
                >
                    <div class="counter-big-num mb-0 font-weight-400">
                        <span class="counter">500</span>
                    </div>
                    <p
                            class="lead mb-0 py-4 font-weight-600 position-relative z-bigger color-dark-blue"
                    >
                        Rajput Youths
                    </p>
                </div>
                <div
                        class="col-md-6 col-lg-3 mt-5 mt-lg-0 text-center border-counters-right"
                >
                    <div class="counter-big-num mb-0 font-weight-400">
                        <span class="counter">5K</span>+
                    </div>
                    <p
                            class="lead mb-0 py-4 font-weight-600 position-relative z-bigger color-dark-blue"
                    >
                        Events
                    </p>
                </div>
                <div class="col-md-6 col-lg-3 mt-5 mt-lg-0 text-center">
                    <div class="counter-big-num mb-0 font-weight-400">
                        <span class="counter">15</span>
                    </div>
                    <p
                            class="lead mb-0 py-4 font-weight-600 position-relative z-bigger color-dark-blue"
                    >
                        Chapters
                    </p>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-6 col-md-4 col-lg-3 text-center">
                    <div class="section divider"></div>
                </div>
            </div>
        </div>
    </div>
</div>
